import React from 'react';
import Swal from 'sweetalert2';
import IvicosStrings from 'kits/language/stringKit';
import { consumeLobbyRedirectReason, LobbyRedirectReason } from 'features/Rooms/RoomList/helpers/lobbyRedirect';

interface ILobbyRedirectModalProps {
    themeColor?: string;
}

const LobbyRedirectModal: React.FC<ILobbyRedirectModalProps> = ({ themeColor }) => {
    React.useEffect(() => {
        const reason = consumeLobbyRedirectReason();
        if (!reason) return;

        const copy: Record<LobbyRedirectReason, { text: string; button: string }> = {
            'inactivity-detected': {
                text: IvicosStrings.lobbyModalInactivityDetectedText,
                button: IvicosStrings.lobbyModalInactivityDetectedButton
            },
            'ooo-inactivity': {
                text: IvicosStrings.lobbyModalOooInactivityText,
                button: IvicosStrings.lobbyModalOooInactivityButton
            },
            'status-updated': {
                text: IvicosStrings.lobbyModalStatusUpdatedText,
                button: IvicosStrings.lobbyModalStatusUpdatedButton
            },
            'midnight-status-update': {
                text: IvicosStrings.lobbyModalMidnightStatusUpdateText,
                button: IvicosStrings.lobbyModalMidnightStatusUpdateButton
            }
        };

        const { text, button } = copy[reason];

        setTimeout(() => {
            Swal.fire({
                icon: 'info',
                text,
                confirmButtonText: button,
                confirmButtonColor: themeColor || '#0078d4',
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: { popup: 'fluent-ui-font' }
            });
        }, 1000);
    }, []);

    return null;
};

export default LobbyRedirectModal;
